<template>
    <div class="stepThree">
        <Spin size="large" fix v-if="spinShow"></Spin>
        <headers></headers>
        <div class="content">
            <steps :step-num="2"></steps>
            <div class="stepThree-form">
                <div class="stepTow-tip"><Icon type="md-alert" /> 检测到您在我校已绑定手机号 {{phoneNum}}，请使用短信验证码激活。如预置手机号有误，请“钉钉”联系信息中心阮月光老师。</div>
                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="0">
                    <FormItem prop="password">
                        <Input v-model="formValidate.password" type="password" password placeholder="请输入新密码" />
                    </FormItem>
                    <FormItem prop="passwords">
                        <Input v-model="formValidate.passwords" type="password" password placeholder="请确认新密码" />
                    </FormItem>
                    <FormItem>
                        <Button type="primary" long @click="handleSubmit('formValidate')">下一步</Button>
                    </FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import headers from '../../components/pc/header.vue'
    import steps from '../../components/pc/mStep.vue'
    import * as utils from '../../utils'
    export default {
        name: "stepThree",
        components: {
            headers,
            steps
        },
        data() {
            const validatePassCheck = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认新密码'));
                } else if (value !== this.formValidate.password) {
                    callback(new Error('确认密码不一致'));
                } else {
                    callback();
                }
            };
            return {
                spinShow: false,
                formValidate: {
                    password: '',
                    passwords: '',
                },
                ruleValidate: {
                    password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
                    passwords: [{ validator: validatePassCheck, trigger: 'blur' }],
                },
            }
        },
        created() {
            if(!this.userInfos.sessionId) {
                this.$router.push({path: '/stepMoOne',query: {service: this.$route.query.service}})
            }
        },
        computed: {
            ...mapState({
                userInfos: state=>state.userInfo,
                cardIds: state=>state.cardId,
            })
        },
        methods: {
            changePwd() {
                utils.Post('https://authserver.nbt.edu.cn/accountActive-nbt/nbtActivateAccount/finishActivate',{
                    sessionId: this.userInfos.sessionId,
                    userAccount: this.userInfos.userAccount,
                    userPwd: this.formValidate.password,
                }).then(res => {
                    this.$router.push({path: '/stepMoFour',query: {service: this.$route.query.service}})
                })
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.spinShow = true
                        utils.Post('https://authserver.nbt.edu.cn/accountActive-nbt/nbtActivateAccount/pwdComplexity',{
                            pwd: this.formValidate.password,
                        }).then(res => {
                            if(res.data.errCode == '0') {
                                this.changePwd()
                            } else {
                                this.$Message.warning(res.data.errMsg)
                            }
                            this.spinShow = false
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .content{
        width: 90%;
        margin: 50px auto 0;
    }
    .stepThree-form{
        width: 100%;
        margin: 50px auto 0;
    }
    .stepTow-tip{
        padding: 3px 5px;
        background: #bceaff;
        display: flex;
        align-items: center;
        color: #000;
        justify-content: center;
    }
    .stepTow-tip i{
        color: #2d8cf0;
        font-size: 26px;
        margin-right: 5px;
    }
</style>



// WEBPACK FOOTER //
// stepThree.vue?75027e7c